import { LegalChrome } from './LegalChrome';
import { SUPPORT_EMAIL } from './constants';

const LAST_UPDATED = 'May 9, 2026';

export function PrivacyChoicesPage() {
  return (
    <LegalChrome>
      <h1 className="legal-h1">Kynward Privacy Choices</h1>
      <p className="legal-muted">Last updated: {LAST_UPDATED}</p>

      <p className="legal-p">
        Kynward gives you control over the personal information you share with us. This page
        explains how you can access, update, delete, or make choices about how your data is used.
      </p>

      <h2 className="legal-h2">Update your information</h2>
      <p className="legal-p">
        You can update much of your account information directly in the Kynward app, including:
      </p>
      <ul className="legal-ul">
        <li className="legal-li">Profile details</li>
        <li className="legal-li">Profile photo</li>
        <li className="legal-li">City or location settings</li>
        <li className="legal-li">Interests and circle preferences</li>
        <li className="legal-li">Notification preferences</li>
      </ul>
      <p className="legal-p">
        To update your information, open Kynward and go to:
        <br />
        <br />
        Settings → Account
        <br />
        or
        <br />
        Settings → Profile
      </p>

      <h2 className="legal-h2">Delete your account and data</h2>
      <p className="legal-p">
        You can request deletion of your Kynward account directly in the app.
        <br />
        <br />
        Open Kynward and go to:
        <br />
        <br />
        Settings → Account → Delete Account
      </p>
      <p className="legal-p">
        Deleting your account removes your profile and personal account data from Kynward, except
        for information we are required or permitted to retain for legal, safety, security, fraud
        prevention, dispute resolution, subscription, or compliance purposes.
      </p>
      <p className="legal-p">
        Some content may remain in limited form when necessary to protect other users, preserve
        safety records, investigate reports, or comply with legal obligations.
      </p>

      <h2 className="legal-h2">Access or export your data</h2>
      <p className="legal-p">
        You may request a copy of personal data associated with your Kynward account by contacting
        us at:
      </p>
      <p className="legal-p">
        <a className="legal-a" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </p>
      <p className="legal-p">
        Please include the email address associated with your Kynward account so we can verify your
        request.
      </p>

      <h2 className="legal-h2">Change how your data is used</h2>
      <p className="legal-p">
        Kynward uses data to provide core app features, including account creation, matching,
        Circles, safety, moderation, subscriptions, support, and app improvement.
      </p>
      <p className="legal-p">You can control certain uses of your data by:</p>
      <ul className="legal-ul">
        <li className="legal-li">Updating your profile and preferences in the app</li>
        <li className="legal-li">
          Changing notification settings in the app or your device settings
        </li>
        <li className="legal-li">Deleting your account</li>
        <li className="legal-li">Contacting us to request access, correction, or deletion</li>
      </ul>
      <p className="legal-p">
        Kynward does not sell your personal information. Kynward does not share your personal
        information with data brokers.
      </p>

      <h2 className="legal-h2">Third-party services</h2>
      <p className="legal-p">
        Kynward may use trusted third-party service providers for services such as hosting,
        databases, email delivery, payments, app store subscriptions, analytics, crash reporting,
        moderation, and security. These providers may process data only as needed to provide
        services to Kynward.
      </p>

      <h2 className="legal-h2">Contact</h2>
      <p className="legal-p">For privacy requests or questions, contact:</p>
      <p className="legal-p" style={{ fontWeight: 600 }}>
        Elyxora Works LLC
      </p>
      <p className="legal-p">
        <a className="legal-a" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </p>
    </LegalChrome>
  );
}
